import { fi } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Tervetuloa",
    login: "Kirjaudu sisään",
    logout: "Kirjaudu ulos",
    about: "Tietoja",
    dashboard: "Etusivu",
    products: "Tuotteet",
    users: "Käyttäjät",
    labels: "Etiketit",
    createUser: "Luo käyttäjä",
    editUser: "Muokkaa käyttäjää",
    deleteUser: "Poista käyttäjä",
    userList: "Käyttäjäluettelo",
    productList: "Tuoteluettelo",
    createProduct: "Luo tuote",
    editProduct: "Muokkaa tuotetta",
    deleteProduct: "Poista tuote",
    labelSettings: "Etikettiasetukset",
    createCategory: "Luo kategoria",
    editCategory: "Muokkaa kategoriaa",
    deleteCategory: "Poista kategoria",
    categoryList: "Kategorialuettelo",
    dragToReorder: "Järjestä kategoriat vetämällä",
    name: "Nimi",
    nameFormat: "Nimi (Etunimi Sukunimi)*",
    email: "Sähköposti",
    emailFormat: "Sähköposti*",
    role: "On ylläpitäjä",
    actions: "Toiminnot",
    save: "Tallenna",
    cancel: "Peruuta",
    edit: "Muokkaa",
    delete: "Poista",
    confirmDelete: "Haluatko varmasti poistaa tämän kohteen?",
    yes: "Kyllä",
    no: "Ei",
    search: "Hae...",
    itemsPerPageText: "Kohteita sivulla:",
    pageText: "{0}-{1} / {2}",
    productName: "Tuotteen nimi*",
    productNumber: "Tuotenumero",
    productOnList: "Tuotteen nimi",
    category: "Kategoria",
    categoryOnList: "Kategoria",
    categories: "Kategoriat",
    noCategories: "Ei kategorioita",
    thawingDays: "Sulatus (päivää)",
    notesHint: "Lisätietoja tästä tuotteesta",
    refridgeDays: "Jääkaappi (päivää)",
    threeHoursHint: "Voiko tuote olla huoneenlämmössä 3 tuntia?",
    allergens: "Allergeenit",
    selectAllergens: "Valitse allergeenit",
    noAllergens: "Ei allergeeneja",
    notes: "Muistiinpano",
    daysUntilExpiration: "Päiviä viimeiseen käyttöpäivään",
    daysNeededForThawing: "Sulatukseen tarvittavat päivät",
    daysInRefrigeration: "Päiviä jääkaapissa",
    producedDateLabel: "Valmistuspäivä",
    openedDateLabel: "Avauspäivä",
    createdAt: "Luotu",
    updatedAt: "Päivitetty",
    expirationDate: "Viimeinen käyttöpäivä",
    openedDate: "Avauspäivä",
    producedDate: "Valmistuspäivä",     
    numLabels: "Etikettien määrä",
    quantity: "Määrä",
    foodItems: "Tuotteet",
    printSelected: "Tulosta valitut",
    mandatoryField: "osoittaa pakollisen kentän",
    categoryName: "Kategorian nimi*",
    description: "Kuvaus",
    descriptionHint: "Rivinvaihto Enterillä",
    standardCategory: "Oletuskategoria",
    fieldRequired: "Kenttä on pakollinen",
    standard: "Oletus",
    devices: "Laitteet",
    deviceNick: "Laitteen lempinimi",
    deviceID: "Laitetunnus",
    confirmDeleteDevice: "Haluatko varmasti poistaa laitteen:",
    userAdministration: "Käyttäjien hallinta",
    newPasswordOptional: "Uusi salasana (valinnainen)",
    passwordFormat: "Salasana*",
    password: "Salasana",
    admin: "Ylläpitäjä",
    printFooditems: "Tulosta etiketit",
    fromFooditems: "elintarvikkeista",
    loadingHomepage: "Ladataan etusivua...",
    pleaseLogin: "Kirjaudu sisään päästäksesi etusivulle",
    settings: "Asetukset",
    displaySettings: "Näyttöasetukset",
    theme: "Teema",
    light: "Vaalea",
    dark: "Tumma",
    language: "Kieli",  
    selectLanguage: "Valitse kieli",
    finnish: "Suomi",
    danish: "Tanska",
    english: "Englanti",
    swedish: "Ruotsi",
    norweigian: "Norja",
    german: "Saksa",
    japaneese: "Japani",
    selectedLabel: "Valittu etiketti",
    dataManagement: "Tiedonhallinta",
    importData: "Tuo tietoja",
    exportData: "Vie tietoja",
    importExport: "Tuonti / Vienti",
    exportProducts: "Vie tuotteet",
    importProducts: "Tuo tuotteet",
    selectFile: "Valitse tiedosto",
    upload: "Lataa",
    download: "Lataa tiedosto",
    dataImportSuccess: "Tiedot tuotiin onnistuneesti",
    dataImportError: "Virhe tietojen tuonnissa",
    importProductsSubtitle: "Tuo tuotteet xlsx-tiedostosta.",
    useCategories: "Näytä kategoriat",
    defaultLabel: "Oletusetiketti",
    defaultLabelHint: "Valitse etiketti, joka on esivalittuna tulostettaessa.",
    noLabelsAvailable: "Ei etikettejä saatavilla",
    copy: "Kopio",
    useAliasAsTitle: "Käytä aliasta otsikkona",
    useAliasAsTitleHint: "Käytä Alias-kenttää tuotteen nimen sijaan. Jos alias on tyhjä, käytetään tuotteen nimeä.",
    menus: "Valikot",
    locations: "Toimipisteet",
    deleteSelected: "Poista valitut",
    confirmDeleteSelected: "Haluatko varmasti poistaa {count} tuotetta?",
    create: "Luo",
    createNewCategory: "Luo uusi kategoria",
    nutritionProfile: "Ravintoprofiili",
    nutritionProfileHint: "Käytetään etikettien ravintosisältöelementissä.",
    noNutritionProfiles: "Ei vielä ravintoprofiileja",
    days: "Päivää",
    hours: "Tuntia",
    alias: "Alias",
    barcode: "Viivakoodi",

    // Label Designer
    labelDesigner: "Etikettisuunnittelija",
    saveLabel: "Tallenna etiketti",
    refresh: "Päivitä",
    selectLabel: "Valitse etiketti",
    createNewLabel: "Luo uusi etiketti",
    labelName: "Etiketin nimi",
    width: "Leveys (mm)",
    height: "Korkeus (mm)",
    titleFont: "Otsikon fontti (pt)",
    titleX: "Otsikko X (mm)",
    titleY: "Otsikko Y (mm)",
    active: "Aktiivinen",
    addField: "Lisää kenttä",
    fieldType: "Kentän tyyppi",
    labelText: "Kentän teksti",
    baseDate: "Peruspäivä",
    offsetField: "Siirtymäkenttä",
    databaseField: "Tietokantakenttä",
    xPosition: "X-sijainti (mm)",
    yPosition: "Y-sijainti (mm)",
    fontSize: "Fonttikoko (pt)",
    qrSize: "QR-koodin koko (mm)",
    preview: "Esikatselu",
    sampleItemName: "Esimerkkituotteen nimi",
    size: "Koko",
    scale: "Mittakaava",
    fieldsCount: "Kentät",
    newLabel: "Uusi etiketti",
    newField: "Uusi kenttä",
    labelSaved: "Etiketti tallennettu!",
    loadLabelsFailed: "Etikettejä ei voitu ladata",
    saveLabelFailed: "Etikettiä ei voitu tallentaa",
    labelPrinting: "Etikettien tulostus",
    productsPerPage: "Kohteita sivulla",
    showAll: "Näytä kaikki",
    selectAtLeastOne: "Valitse vähintään yksi kohde.",
    noLabelSelected: "Etikettiä ei ole valittu. Valitse etiketti asetuksista.",
    labelColor: "Etiketin väri",
    creditZplImage: "ZPL-kuvalisäosan kehittäjä: ",
    fieldTypePrompt: "Syöttökehote",
    promptDialogTitle: "Syöttö",

    // Label Type
    labelType: "Etiketin tyyppi",
    labelTypeStandard: "Oletus",
    labelTypeFreetext: "Vapaa teksti",
    freetextNotice: "Vapaan tekstin etiketit ovat tyhjiä kenttiä, joihin kirjoitetaan suoraan tabletilla. Tuotteen nimeä tai valmiita kenttiä ei näytetä.",

    // Logo
    logo: "Logo",
    logoReplace: "Korvaa",
    logoUpload: "Lataa",
    logoRemove: "Poista",
    logoNoLogo: "Logoa ei ole ladattu. Lisää logo asettaaksesi sen etikettiin.",
    logoUploadTitle: "Lataa logo",
    logoSelectFile: "Valitse PNG-kuva",
    logoSelectFileHint: "Lataa kuva valmiiksi käännettynä, kuten haluat sen tulostuvan.",
    logoWidthOnLabel: "Leveys etiketissä (mm)",
    logoWidthHint: "Korkeus lasketaan automaattisesti",
    logoPrinterDpi: "Tulostimen DPI",
    logoOriginal: "Alkuperäinen",
    logoTarget: "Tavoite",
    logoBlackThreshold: "Mustan kynnysarvo",
    logoBlackThresholdHint: "Pienempi = vain tummat pikselit muuttuvat mustiksi. Suurempi = myös vaaleammat muuttuvat.",
    logoPreviewOriginal: "Alkuperäinen",
    logoPreviewMono: "Yksivärinen (kuten tulostettuna)",
    logoApply: "Käytä",
    logoLoaded: "Logo ladattu ({width}×{height}mm). Aseta se etikettiin alla olevilla X/Y-arvoilla.",
    logoNotUploaded: "Logoa ei ole vielä ladattu. Siirry kohtaan Etikettiasetukset → Logo ladataksesi logon.",
    logoUploaded: "Logo ladattu ja muunnettu",
    logoUploadFailed: "Logon lataaminen epäonnistui",
    logoProcessFailed: "Logon käsittely epäonnistui",
    logoInvalidDimensions: "Virheelliset mitat",
    logoNoFile: "Tiedostoa ei ole valittu",

    // Field Types (dropdown titles)
    fieldTypeDate: "Päivämäärä",
    fieldTypeDatePlus: "Päivämäärä + päivät",
    fieldTypeDatabase: "Tietokantakenttä",
    fieldTypeQrcode: "QR-koodi",
    fieldTypeBarcode: "Viivakoodi (Code128)",
    fieldTypeLogo: "Logokuva",
    fieldTypeValueOnly: "Vain arvo (vapaa sijoittelu)",
    fieldTypeAllergensText: "Allergeeniteksti",
    fieldTypeStatic: "Kiinteä teksti",
    fieldTypeDivider: "Erotinviiva",

    // Value Only sub-types
    valueType: "Arvon tyyppi",
    valueTypeDate: "Päivämäärä",
    valueTypeDatePlus: "Päivämäärä + päivät",
    valueTypeDatabase: "Tietokantakenttä",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Kierto",

    // Separator & value position
    separator: "Erotin",
    separatorHint: "Teksti otsikon ja arvon välissä. Jätä tyhjäksi, jos et halua erotinta.",
    separatorPlaceholder: ": ",
    valueXMm: "Arvo X (mm)",
    valueXHint: "Jätä tyhjäksi sijoittaaksesi otsikon perään",
    valueYMm: "Arvo Y (mm)",
    valueYHint: "Jätä tyhjäksi käyttääksesi otsikon Y-arvoa",
    valueFontSize: "Arvon fonttikoko",
    valueFontSizeHint: "Jätä tyhjäksi käyttääksesi otsikon kokoa",

    // Font style
    bold: "Lihavoitu",
    italic: "Kursivoitu",

    // Text alignment
    textAlignment: "Tekstin tasaus",
    alignLeft: "Vasen",
    alignCenter: "Keskitetty",
    alignRight: "Oikea",

    // QR Code
    qrDataSource: "QR-tietolähde",

    // Barcode
    barcodeDataSource: "Tietolähde",
    barcodeWidthMm: "Viivakoodin leveys (mm)",
    barcodeHeightMm: "Viivakoodin korkeus (mm)",
    barcodeDisplayValue: "Näytä arvo viivakoodin alla",

    // Allergens text
    allergenSeparator: "Erotin",
    allergenSeparatorHint: "Merkit allergeenien nimien välissä (esim. ', ' tai ' / ')",

    // Divider
    dividerLineWidth: "Viivan leveys (mm)",
    dividerLineWidthHint: "Erotinviivan leveys",
    dividerLineThickness: "Viivan paksuus (mm)",
    dividerLineThicknessHint: "Viivan paksuus",

    // Date Base
    
    // Database Fields
    fridgeValue: "Jääkaappiarvo",
    fridgeValueHint: "esim. ENNEN AVAAMISTA",
    threeHours: "Kolme tuntia (KYLLÄ/EI)",
    itemName: "Tuotteen nimi",
    
    // Offset Fields
    thawingDaysOffset: "Sulatuspäivät",
    refrigeratedDaysOffset: "Jäähdytyspäivät",
    expiryDays: "Säilyvyys (päivää)",
    thawingHours: "Sulatustunnit",
    refrigeratedHours: "Jäähdytystunnit",
    expiryHours: "Säilyvyys (tuntia)",
    showTime: "Näytä kellonaika",
    
    // QR Data Fields
    itemId: "Tuotetunnus",
    customUrl: "Mukautettu URL",
    customData: "Mukautettu data",

    // Snackbar / status messages
    labelSavedSuccess: "Etiketti tallennettu",
    labelSaveFailed: "Etikettiä ei voitu tallentaa",
    labelLoadFailed: "Etikettejä ei voitu ladata",
    labelLoadSingleFailed: "Etikettiä ei voitu ladata",
    fieldOrderUpdated: "Kenttien järjestys päivitetty",

    // Labels management view
    labelsDescription: "Hallitse etikettejä — katso tiedot, aktivoi/poista käytöstä tai poista.",
    totalLabels: "Etikettejä yhteensä",
    activeLabels: "Aktiiviset etiketit",
    inactiveLabels: "Ei-aktiiviset etiketit",
    labelsList: "Etiketit",
    searchLabels: "Hae etikettejä...",
    dimensions: "Mitat",
    inactive: "Ei aktiivinen",
    color: "Väri",
    type: "Tyyppi",
    freetext: "Vapaa teksti",
    viewLabel: "Näytä etiketti",
    noLabelsFound: "Etikettejä ei löytynyt",
    createFirstLabel: "Luo ensimmäinen etikettisi",
    namePosition: "Nimen sijainti",
    fieldLabel: "Kentän nimi",
    position: "Sijainti",
    noFields: "Kenttiä ei ole määritetty",
    hasLogo: "Logo lisätty",
    status: "Tila",
    editInDesigner: "Muokkaa suunnittelijassa",
    confirmDeleteText: "Haluatko varmasti poistaa kohteen '{labelName}'? Toimintoa ei voi kumota.",
    deleteWarning: "Kaikki tähän etikettiin liittyvät kentät poistetaan myös.",
    labelActivated: "'{name}' on nyt aktiivinen",
    labelDeactivated: "'{name}' ei ole enää aktiivinen",
    labelToggleError: "Etiketin tilaa ei voitu muuttaa",
    labelDeleted: "'{name}' on poistettu",
    labelDeleteError: "Etiketin poisto epäonnistui",
    close: "Sulje",
    deleteLabel: "Poista etiketti",

    // device management
    devicesDescription: "Hallitse laitteita ja lisenssejä.",
    totalLicenses: "Lisenssejä yhteensä",
    usedLicenses: "Käytetyt lisenssit",
    availableLicenses: "Vapaat lisenssit",
    devicesList: "Laitteet",
    searchDevices: "Hae laitteita...",
    deleteDevice: "Poista laite",
    noDevicesFound: "Laitteita ei löytynyt",
    noDevicesHint: "Laitteet rekisteröityvät sovelluksen kautta.",
    deleteDeviceHint: "Laite on rekisteröitävä uudelleen ennen käyttöä.",
    deviceDeleted: "'{name}' on poistettu",
    deviceDeleteError: "Laitetta ei voitu poistaa",
    canEdit: "Voi muokata",
    cannotEdit: "Ei voi muokata",
    canEditProducts: "Muokkaus",
    allowEditing: "Salli muokkaus",
    disableEditing: "Poista muokkaus käytöstä",
    editingEnabled: "Muokkaus käytössä",
    editingDisabled: "Muokkaus poistettu käytöstä",
    selected: "valittu",
    updateError: "Päivitys epäonnistui",
    canDelete: "Voi poistaa",
    cannotDelete: "Ei voi poistaa",
    canDeleteProducts: "Poistaminen",
    allowDeleting: "Salli poistaminen",
    disableDeleting: "Poista poistaminen käytöstä",
    deletingEnabled: "Poistaminen käytössä",
    deletingDisabled: "Poistaminen poistettu käytöstä",
    editingDisabledCascade: "Muokkaus poistettu käytöstä — myös poistaminen poistettiin käytöstä",
    deletingEnabledCascade: "Poistaminen käytössä — myös muokkaus otettiin käyttöön",
    allowBackdating: "Salli takautuva päiväys",
    disallowBackdating: "Poista takautuva päiväys käytöstä",
    backdatingEnabled: "Takautuva päiväys käytössä",
    backdatingDisabled: "Takautuva päiväys poistettu käytöstä",
    backdatingDisabledCascade: "Takautuva päiväys poistettu käytöstä — myös muokkaus poistettiin käytöstä",
    backdatingEnabledCascade: "Takautuva päiväys käytössä — myös muokkaus otettiin käyttöön",
    backdatingOff: "Takautuva päiväys poistettu käytöstä",
    backdatingOn: "Takautuva päiväys käytössä",
    maxBackdateDays: "Takautuvan päiväyksen enimmäispäivät",
    maxBackdateDaysHint: "Määritä, kuinka monta päivää taaksepäin käyttäjä voi valita valmistus-/avauspäivän. 0 poistaa takautuvan päiväyksen käytöstä.",

    // Configurations Page
    configurations: "Määritykset",
    globalSettings: "Yleiset asetukset",
    globalSettingsHint: "Nämä asetukset koskevat kaikkia tilin tabletteja. Tallennus nostaa versiota, joten tabletit hakevat uudet asetukset.",
    tabletFields: "Tabletin kentät",
    tabletFieldConfig: "Tabletin kenttäasetukset",
    tabletFieldConfigHint: "Määritä, mitkä kentät näkyvät luotaessa tai muokattaessa tuotteita tableteilla.",
    tabletFieldConfigInfo: "Järjestä vetämällä. Piilotetut kentät eivät näy tabletin valintaikkunoissa. Pakolliset kentät on täytettävä ennen tallennusta.",
    freetextLabels: "Vapaan tekstin etiketit",
    freetextLabelsOverview: "Vapaan tekstin etiketit",
    freetextLabelsHint: "Kaikki vapaan tekstin etiketit, mukaan lukien paikalliset tablettietiketit. Paikalliset etiketit näkyvät vain ne luoneella laitteella.",
    noFreetextLabels: "Vapaan tekstin etikettejä ei löytynyt.",
    reassignToDevice: "Määritä laitteelle",
    reassignHint: "Valitse laite, jolle tämä vapaan tekstin etiketti määritetään. Se ei enää näy alkuperäisellä laitteella.",
    labelsSelected: "{count} etikettiä valittu",
    targetDevice: "Kohdelaite",
    markAsLocal: "Merkitse paikalliseksi",
    reassign: "Määritä",
    moveToDevice: "Siirrä laitteelle",
    removeFromAll: "Poista kaikilta laitteilta",
    broadcastNewLabel: "Lähetä uusi etiketti usealle laitteelle",
    broadcastNew: "Luo uusi",
    broadcast: "Julkaise",
    freetextContent: "Vapaan tekstin sisältö",
    selectAll: "Valitse kaikki",
    deselectAll: "Poista kaikki valinnat",
    selectDevices: "Valitse laitteet",
    broadcastDevices: "Lähetä {count} laitteelle",
    devicesSelected: "{count} laitetta valittu",
    pushToDevices: "Lähetä {count} laitteelle",
    pushExistingHint: "Lähetä olemassa oleva etiketti usealle laitteelle.",
    activeBroadcasts: "Aktiiviset lähetykset",
    broadcastsHint: "Vapaan tekstin etiketit, jotka on tällä hetkellä lähetetty usealle laitteelle. Ne pysyvät aktiivisina, kunnes ne poistetaan käsin kaikilta laitteilta tai määritetään yhdelle laitteelle.",
    noBroadcasts: "Ei aktiivisia lähetyksiä",
    valuesInDays: "päivää",
    valuesInHours: "tuntia",
    showAlias: "Näytä alias",
    showAliasHint: "Näytä Alias-kenttä tabletin aloitusnäytössä tuotteen nimen alla.",
    showMenuTab: "Näytä valikkovälilehti",
    showMenuTabHint: "Näytä aktiivinen valikko välilehtenä tabletin aloitusnäytössä",
    hideCategoryAll: "Piilota Kaikki-kategoria",
    hideCategoryAllHint: "Piilota Kaikki-kategoria tablettien kategoriavalikosta",

    // Global Settings Toggles
    useCategoriesHint: "Näytä kategoriavalikko tableteilla ja kategorian valinta tuotteita luotaessa",
    usePrintDialog: "Näytä tulostusikkuna",
    usePrintDialogHint: "Näytä päivämäärän valintaikkuna ennen etikettien tulostusta tableteilla",
    showTimestampOnDates: "Näytä kellonaika päivämäärissä",
    showTimestampOnDatesHint: "Sisällytä TT:MM-aikaleima päivämääräetiketteihin (esim. 17/02/26 10:30)",
    showCategoryOnProduct: "Näytä kategoria tuotteessa",
    showCategoryOnProductHint: "Näytä kategorian nimi tuotteen nimen alla tabletin aloitusnäytössä",
    todaysDateInclusive: "Kuluva päivä mukaan luettuna",
    todaysDateInclusiveHint: "Laske kuluva päivä mukaan viimeisen käyttöpäivän laskentaan (esim. 3 päivää maanantaista = keskiviikko torstain sijaan)",
    settingsVersionInfo: "Nykyinen versio",
    settingsVersionHint: "Vanhempaa versiota käyttävät tabletit hakevat päivitetyt asetukset seuraavalla päivityksellä.",
    saveChanges: "Tallenna muutokset",

    // Field Config Table
    fieldName: "Kenttä",
    customLabel: "Mukautettu otsikko",
    visible: "Näkyvä",
    required: "Pakollinen",

    // Freetext Table
    content: "Sisältö",
    device: "Yksikkö",
    scope: "Laajuus",
    updated: "Päivitetty",
    local: "Paikallinen",
    global: "Yleinen",
    confirmDeleteFreetext: "Haluatko varmasti poistaa tämän vapaan tekstin etiketin?",
    freetextSizes: "Saatavilla olevat koot",
    freetextSizesHint: "Luettelo saatavilla olevista vapaan tekstin koista.",
    createSize: "Luo koko",
    createFreetextSize: "Luo vapaan tekstin koko",
    widthMm: "Leveys (mm)",
    heightMm: "Korkeus (mm)",
    freetextSizeWhiteHint: "Vapaan tekstin etiketit näytetään valkoisina",
    default: "Oletus",
    setAsDefault: "Aseta oletukseksi",
    cancelDefault: "Poista oletus",

    // Location management
    locationName: "Toimipisteen nimi",
    assignUser: "Määritä käyttäjä",
    assignedUsers: "Määritetyt käyttäjät",
    noUsersAssigned: "Ei määritettyjä käyttäjiä",
    addUsers: "Lisää käyttäjiä",
    selectUsers: "Valitse käyttäjät",
    assignProducts: "Määritä tuotteet",
    assignedProducts: "Määritetyt tuotteet",
    availableProducts: "Saatavilla olevat tuotteet",
    noProductsAssigned: "Ei määritettyjä tuotteita",
    allProductsAssigned: "Kaikki tuotteet määritetty",
    countryCode: "Maakoodi",
    timezone: "Aikavyöhyke",
    createdLocation: "Toimipiste luotu",
    editLocation: "Muokkaa toimipistettä",
    totalLabelsPrinted: "Tulostettuja etikettejä yhteensä",
    clickForBreakdown: "Napsauta nähdäksesi tarkan erittelyn",
    printStatsTitle: "Tulostustilastot",
    noPrintEvents: "Toimipisteille ei löytynyt tulostustilastoja",
    labelsPrintedTotal: "etikettiä tulostettu yhteensä",
    since: "alkaen",
    createLocation: "Luo toimipiste",

    //Tickets System
    createTicket: "Luo tiketti",
    ticketType: "Tiketin tyyppi",
    ticketTypeSale: "Myynti",
    ticketTypeSupport: "Tuki",
    ticketTypeBug: "Virheilmoitus",
    ticketTitle: "Otsikko",
    ticketDescriptionHint: "Kuvaile ongelmasi tai pyyntösi yksityiskohtaisesti",
    ticketReporter: "Ilmoittaja",
    ticketCreated: "Tiketti luotu",
    priority: "Prioriteetti",
    priorityHint: "Jätä tyhjäksi, jolloin järjestelmä päättää tiketin sisällön perusteella, tai valitse itse",
    priorityAuto: "Automaattinen",
    priorityLow: "Matala",
    priorityMedium: "Keskitaso",
    priorityHigh: "Korkea",
    priorityUrgent: "Kiireellinen",
    submit: "Lähetä tiketti",
    tickets: "Tiketit",
    orderAccessories: "Tilaa etikettejä ja tarvikkeita",
    ticketLogHint: "Luettelo Capture IT:lle lähetetyistä tukipyynnöistä.",

    impersonation: {
        menuItem: "Siirry asiakkaan tilille",
        title: "Siirry asiakkaan tilille",
        subtitle: "Valitse asiakas työskennelläksesi hänen tilillään. Kaikki tekemäsi kohdistuu hänen oikeisiin tietoihinsa.",
        search: "Hae asiakkaan, tilinumeron tai sähköpostin perusteella...",
        customer: "Asiakas",
        lastPrint: "Viimeksi tulostettu",
        enter: "Siirry",
        noCustomers: "Asiakkaita ei löytynyt",
        loadFailed: "Asiakasluetteloa ei voitu ladata",
        confirmTitle: "Siirrytäänkö asiakkaan tilille?",
        confirmText: "Olet avaamassa asiakkaan {customer} tilin hänen oman ylläpitäjänsä oikeuksilla.",
        confirmWarning: "Kaikki tekemäsi kohdistuu asiakkaan oikeisiin tietoihin. Istunto kirjataan lokiin ja päättyy automaattisesti 2 tunnin kuluttua.",
        bannerTitle: "Työskentelet asiakkaan {customer} tilillä",
        bannerSubtitle: "Taustalla kirjautuneena omana itsenäsi ({user})",
        stop: "Poistu",
        actions: "Toiminnot",
    },       

    designer: {
        untitled: "Nimetön",
        noLabel: "Etikettiä ei ole valittu",
        saved: "Tallennettu",
        saveError: "Tallennus epäonnistui",
        unsavedTitle: "Tallentamattomia muutoksia",
        unsavedConfirm: "Sinulla on tallentamattomia muutoksia. Haluatko poistua sivulta?",
        leaveAnyway: "Poistu silti",
        stay: "Pysy sivulla",
        toggleGrid: "Näytä/piilota ruudukko",
        preview: "Esikatselu",
        undo: "Kumoa",
        redo: "Tee uudelleen",
        save: "Tallenna",
        print: "Tulosta",
        back: "Takaisin",
    },
    fields: {
        productFields: "Tuotekentät",
        productField: "Tuotekenttä",
        barcodes: "Viivakoodit",
        layout: "Asettelu",
        qrCode: "QR-koodi",
        staticText: "Kiinteä teksti",
        imageLogo: "Logokuva",
        divider: "Erotinviiva",
        productNumber: "Tuotenumero",
        productName: "Tuotteen nimi",
        description: "Kuvaus",
        costPrice: "Ostohinta",
        salesPrice: "Myyntihinta",
        currency: "Valuutta",
    },
    common: {
        none: "Ei mitään",
        save: "Tallenna",
        cancel: "Peruuta",
        delete: "Poista",
        close: "Sulje",
        edit: "Muokkaa",
        copy: "Kopioi",
        unsaved: "Tallentamattomia muutoksia",
        loading: "Ladataan...",
        error: "Virhe",
        success: "Onnistui",
    },
    label: {
        name: "Etiketin nimi",
        width: "Leveys (mm)",
        height: "Korkeus (mm)",
        color: "Väri",
        colour: "Väri",
        type: "Tyyppi",
        grid: "Ruudukko",
        gridSize: "Ruudukon koko (mm)",
        active: "Aktiivinen",
        unit: "Yksikkö",
        mm: "mm",
        inch: "tuuma",
    },
    canvas: {
        grid: "Näytä ruudukko",
        gridSize: "Ruudukon koko (mm)",
        layers: "Tasot",
        noElements: "Ei elementtejä",
    },
    importFromOld: "Tuo vanhasta järjestelmästä",
    selectLabelsToImport: "Valitse tuotavat etiketit",
    importHint: "Etiketit tuodaan uuteen järjestelmään. Alkuperäinen säilytetään.",
    importCount: "Tuo {n} etikettiä",
    newDesign: "Uusi etiketti",
    designs: "Etiketit",
    searchDesigns: "Hae etikettejä...",
    totalDesigns: "Etikettejä yhteensä",
    activeDesigns: "Aktiiviset etiketit",
    inactiveDesigns: "Ei-aktiiviset etiketit",
    designCreated: "Etiketti luotu",
    designCopied: "Etiketti kopioitu",
    designDeleted: "Etiketti poistettu",
    designsDeleted: "Etiketit poistettu",
    deleteDesign: "Poista etiketti",
    deleteDesignConfirm: "Haluatko varmasti poistaa kohteen '{name}'?",
    bulkDelete: "Poista valitut",
    bulkDeleteConfirm: "Haluatko varmasti poistaa {n} etikettiä?",
    errorCreating: "Etiketin luonti epäonnistui",
    errorUpdating: "Etiketin päivitys epäonnistui",
    errorCopying: "Etiketin kopiointi epäonnistui",
    errorDeleting: "Etiketin poisto epäonnistui",
    errorLoading: "Etikettejä ei voitu ladata",
    importSuccess: "{n} etikettiä tuotu",
    importError: "Virhe tuonnissa",
    labelsSubtitle: "Hallitse etikettejäsi",
    roundExpiryDownToQuarter: "Pyöristä viimeinen käyttöaika alaspäin lähimpään varttiin",
    roundExpiryDownToQuarterHint: "Vain kun säilyvyys on tunteina. Klo 16:07 päättyvä näytetään muodossa 16:00 — aina alaspäin, jotta säilyvyys ei ylity",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "Etiketti \"{label}\" ei ole aktiivinen — tulostetaan etiketillä \"{fallback}\"",
    labelMissingFallback: "Etikettiä ei ole valittu — tulostetaan etiketillä \"{fallback}\"",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Poistetaanko valitut kategoriat?",
    bulkDeleteWarning: "Toimintoa ei voi kumota.",
    categoriesInUseTitle: "Kategoriat ovat käytössä",
    categoriesInUseText: "Näissä kategorioissa on edelleen tuotteita:",
    moveProductsTo: "Siirrä tuotteet kategoriaan",
    moveAndDelete: "Siirrä ja poista",
    noReassignTarget: "Kaikki kategoriat on valittu. Poista valinta vähintään yhdestä, johon tuotteet voidaan siirtää.",
    categoriesDeleted: "kategoriaa poistettu",
    productsMoved: "tuotetta siirretty",
    defaultCategorySkipped: "oletuskategoria ohitettiin",
    bulkDeleteFailed: "Poistaminen epäonnistui",

    totalLocations: "Toimipisteitä yhteensä",

    productImage: "Tuotekuva",
    chooseFromLibrary: "Valitse kirjastosta",
    changeImage: "Vaihda kuva",
    productImageHint: "Näytetään tabletissa tuotenimen sijaan, jos kuvanäyttö on käytössä",
    productImageLibrary: "Kuvakirjasto",

    productImages: {
        libraryTitle: "Kuvakirjasto",
        libraryHint: "Lataa kaikki tuotekuvat kerralla ja liitä ne tuotteisiin jälkeenpäin.",
        uploadButton: "Lataa kuvia",
        deleteSelected: "Poista valitut",
        uploadProgress: "Ladataan",
        alreadyInLibrary: "On jo kirjastossa",
        noImages: "Ei vielä kuvia",
        preview: "Esikatselu",
        name: "Nimi",
        dimensions: "Mitat",
        usedBy: "Käytössä",
        uploaded: "Ladattu",
        uploadSummary: "{n} kuvaa ladattu",
        uploadSummaryFailed: "{n} ladattu, {failed} epäonnistui",
        uploadSummaryDuplicates: "{n} ladattu, {duplicates} ohitettu kaksoiskappaleina",
        imageRenamed: "Kuvan nimi muutettu",
        renameFailed: "Kuvan nimen muuttaminen epäonnistui",
        confirmDeleteImage: "Haluatko varmasti poistaa tämän kuvan?",
        deleteImageInUseWarning: "{n} tuotetta käyttää tätä kuvaa ja menettää sen.",
        imageDeleted: "Kuva poistettu",
        imageDeletedInUse: "Kuva poistettu — sitä käyttäneillä tuotteilla ei ole enää kuvaa",
        deleteFailed: "Kuvan poistaminen epäonnistui",
        confirmBulkDelete: "Vahvista poisto",
        confirmBulkDeleteText: "Haluatko varmasti poistaa {n} kuvaa?",
        selectedInUseWarning: "{n} valituista kuvista on käytössä ja katoaa niitä käyttäviltä tuotteilta.",
        andMoreCount: "… ja {n} muuta",
        deleteAll: "Poista kaikki",
        imagesDeletedSummary: "{n} kuvaa poistettu",
        imagesDeletedMissing: "{n} kuvaa poistettu ({missing} ei löytynyt)",
        bulkDeleteFailed: "Kuvien poistaminen epäonnistui",

        picker: {
            title: "Valitse kuva",
            uploadNew: "Lataa uusia",
            search: "Hae kuvia...",
            empty: "Kirjastossa ei ole vielä kuvia. Lataa kuvia päästäksesi alkuun.",
            noMatch: "Yksikään kuva ei vastaa hakua",
            removeImage: "Poista kuva",
            uploadFailedCount: "{n} kuvan lataaminen epäonnistui",
        },
    },
    showProductImages: "Näytä tuotekuvat",
    showProductImagesHint: "Näytä tuotekuvat tabletin aloitusnäytössä.",
    showProductNames: "Näytä tuotenimet",
    showProductNamesHint: "Näytä tuotenimet tabletin aloitusnäytössä.",

    productDisplayMode: "Tuotenäkymä",
    displayModeText: "Nimet",
    displayModeImage: "Kuvat",
    displayModeUser: "Käyttäjän valinta",
    mixed: "Sekalainen",
    noDevicesUpdated: "Yhtään laitetta ei päivitetty",
    customFields: "Mukautetut kentät",
    customFieldsHint: "Lisää kenttiä näyttääksesi tiettyjä tuotetietoja",
    noCustomFields: "Ei mukautettuja kenttiä",
    editField: "Muokkaa kenttää",
    fieldLabelHint: "Kentän otsikko",
    fieldPrefixHint: "Kentän etuliite",
    fieldKeyFixedHint: "Kentän avain (ei muutettavissa)",
    deleteFields: "Poista kentät",
    deleteFieldsWarning: "Tämä poistaa valitut kentät pysyvästi",
    deactivateInsteadHint: "Poista käytöstä poistamisen sijaan",
    fieldsDeleted: "Kentät poistettu",
    valuesRemoved: "Arvot poistettu",
    storedValues: "Tallennetut arvot",
    printedPrefix: "Tulostettu etuliite",
    prefix: "Etuliite",
    fieldKey: "Kentän avain",
    values: "Arvot",
    sortOrder: "Järjestys",
    labelRequired: "Otsikko on pakollinen",

    ...designerI18n.fi,
}